import type { RouteStatus } from '../../../services/iam';

// Four distinct states: migrated (done), legacy (works today, not a warning),
// public (deliberate), open (the one real hole - gets the alarm colour).
export const ROUTE_STATUS_LABEL: Record<RouteStatus, string> = {
    migrated: 'Migrated',
    legacy: 'Legacy',
    public: 'Public',
    open: 'Open'
};

export const ROUTE_STATUS_BADGE_CLASS: Record<RouteStatus, string> = {
    migrated: 'bg-emerald-50 text-emerald-700 border-emerald-200',
    legacy: 'bg-blue-50 text-blue-700 border-blue-200',
    public: 'bg-sky-50 text-sky-700 border-sky-200',
    open: 'bg-rose-50 text-rose-700 border-rose-200'
};

export const ROUTE_STATUS_DOT_CLASS: Record<RouteStatus, string> = {
    migrated: 'bg-emerald-500',
    legacy: 'bg-blue-500',
    public: 'bg-sky-500',
    open: 'bg-rose-500'
};

export const ROUTE_STATUS_ORDER: readonly RouteStatus[] = ['migrated', 'legacy', 'public', 'open'];
